

function invoiceManagement() {

  let invoiceService = [
    {
      name: "Invoice Mangement",
      icon: "invoice-management",
      logoName: "MyAccounts",
      // flag: "voucherRequired",
      displayService: "invoiceManagement",
      items: [],
    },
  ];

  const dashboard = () => {
    const dashboardArr = [
      {
        path: "/index/invoice-management",
        name: "Dashboard",
        icon: "dashboard",
        logoName: "dashboard",
        flag: "DASHBOARD",
      },
    ];

    return dashboardArr;
  };

  const MerchantInvoice = () => {
    const profileArr = [
      {
        path: "/index/merchantInvoice",
        name: "Merchant Invoice",
        icon: "merchant-invoice",
        logoName: "merchant invoice",
        flag: "MERCHANT INVOICE",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[profileArr[0].flag])
    // ) {
    return profileArr;
    // } else {
    //   return "";
    // }
  };

  const MerchantConfiguration = () => {
    const mybanksArr = [
      {
        path: "/index/merchantConfiguration",
        name: "Merchant Configuration",
        icon: "merchant-configuration",
        logoName: "merchant configuration1",
        flag: "MERCHANT CONFIGURATION",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[profileArr[0].flag])
    // ) {
    return mybanksArr;
    // } else {
    //   return "";
    // }
  };

  let a = dashboard();
  let b = MerchantInvoice();
  let c = MerchantConfiguration();

  invoiceService[0].items = [...a, ...b, ...c];

  return invoiceService;
}

export default invoiceManagement;
